/**
 * Centralized theme configuration for the Sales Analytics Dashboard
 * Provides consistent colors, spacing, typography, and styling across all components
 */

export const theme = {
  colors: {
    primary: "#f97316",
    secondary: "#3b82f6",
    success: "#22c55e",
    danger: "#ef4444",
    warning: "#f59e0b",
    info: "#06b6d4",

    background: {
      dark: "#0f172a",
      card: "#1a2332",
      hover: "#1e293b",
      light: "#334155",
    },

    text: {
      primary: "#ffffff",
      secondary: "#94a3b8",
      muted: "#64748b",
      disabled: "#475569",
    },

    border: {
      default: "#2a3f5f",
      light: "#334155",
      dark: "#1e293b",
    },

    gradient: {
      card: "linear-gradient(135deg, #1a2332 0%, #1e293b 100%)",
      cardDark: "linear-gradient(135deg, #141b2b 0%, #0f172a 100%)",
      cardLight: "linear-gradient(135deg, #1a2332 0%, #1e293b 100%)",
      primary: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
      success: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
      danger: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    },
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
    "3xl": "64px",
  },

  borderRadius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    full: "9999px",
  },

  typography: {
    fontFamily: {
      sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
      mono: "'Fira Code', 'Courier New', monospace",
    },
    fontSize: {
      xs: "12px",
      sm: "14px",
      base: "16px",
      lg: "18px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px",
      "4xl": "36px",
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  shadows: {
    sm: "0 2px 4px rgba(0,0,0,0.1)",
    md: "0 4px 8px rgba(0,0,0,0.15)",
    lg: "0 8px 24px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.15)",
    xl: "0 16px 40px rgba(15,23,42,0.65), 0 4px 16px rgba(15,23,42,0.7)",
    glow: "0 0 20px rgba(249, 115, 22, 0.3)",
  },

  transitions: {
    fast: "0.15s ease",
    normal: "0.3s ease",
    slow: "0.5s ease",
  },

  zIndex: {
    dropdown: 1000,
    modal: 2000,
    tooltip: 3000,
  },
};

export const getThemeValue = (path) => {
  const keys = path.split('.');
  let value = theme;
  for (const key of keys) {
    value = value?.[key];
    if (value === undefined) return null;
  }
  return value;
};
